module.exports = __webpack_public_path__ + "static/media/tailoredFeature4.20c9a121.svg";